<!-- De inline-editor: één markup voor de nieuw-rij en de bewerk-stand van een tagrij. -->
<ng-template #editorRij>
    <div class="dl-condtagpaneel__editor">
        <input #naamVeld type="text" class="dl-condtagpaneel__editor-invoer"
               [class.dl-condtagpaneel__editor-invoer--fout]="naamIsDuplicaat()"
               [value]="naamInvoer()"
               (input)="naamInvoer.set(naamVeld.value)"
               (keydown.enter)="bewaarEditor()"
               (keydown.escape)="annuleerEditor()">
        <button type="button" class="dl-condtagpaneel__editor-knop"
                [disabled]="!magBewaren()" (click)="bewaarEditor()">
            <span class="fa-solid fa-check" aria-hidden="true"></span>
        </button>
        <button type="button" class="dl-condtagpaneel__editor-knop" (click)="annuleerEditor()">
            <span class="fa-solid fa-xmark" aria-hidden="true"></span>
        </button>
    </div>
</ng-template>

<div class="dl-condtagpaneel__content">
    @if (editor()?.modus === 'nieuw') {
        <div class="dl-condtagpaneel__rij">
            <ng-container [ngTemplateOutlet]="editorRij"/>
        </div>
    }
    <!-- track op de positie, niet op de naam: een conditieset ís zijn naam, dus bij hernoemen zou
         een track op `tag` de rij weggooien en opnieuw opbouwen (NG0956). De rij is hier een plek in
         een gesorteerde lijst; die blijft bij een hernoeming dezelfde. -->
    @for (tag of condtagService.tags(); track $index) {
        <div class="dl-condtagpaneel__rij">
            @if (isInBewerk(tag)) {
                <ng-container [ngTemplateOutlet]="editorRij"/>
            } @else {
                <div class="dl-condtagpaneel__view" (click)="klikView(tag)">
                    <span class="fa-regular" aria-hidden="true"
                          [class.fa-square-check]="condtagService.conditioneleTags()[tag]"
                          [class.fa-square]="!condtagService.conditioneleTags()[tag]"></span>
                </div>
                <div class="dl-condtagpaneel__naam"
                     [class.dl-condtagpaneel__naam--actief]="tag === condtagService.condtag()?.tag"
                     (click)="klikTag(tag)">{{ tag }}
                </div>
                <div class="dl-condtagpaneel__edit">
                    <span class="fa-regular fa-pen-to-square" aria-hidden="true" (click)="startBewerk(tag)"></span>
                </div>
                <div class="dl-condtagpaneel__verwijder">
                    <span class="fa-regular fa-trash-can" aria-hidden="true"
                          [class.dl-condtagpaneel__verwijder--gewapend]="tag === verwijderKandidaat()"
                          [title]="'CONDTAG.VERWIJDERPROMPT' | translate"
                          (click)="klikVerwijder(tag, $event)"></span>
                </div>
            }
        </div>
    }
</div>
<div class="dl-condtagpaneel__tools">
    <button type="button" (click)="klikToggleOpen()">
        <i class="fa-solid" aria-hidden="true"
           [class.fa-angle-up]="!condtagService.open()"
           [class.fa-angle-down]="condtagService.open()"></i>
    </button>
    <div class="dl-condtagpaneel__controls">
        <div class="dl-condtagpaneel__plus">
            @if (magNieuweTag()) {
                <button type="button" (click)="startNieuw()"><i class="fa-solid fa-plus" aria-hidden="true"></i></button>
            }
        </div>
        <div class="dl-condtagpaneel__actief">{{ condtagService.condtag()?.tag || '-' }}</div>
        @if (condtagService.condtag(); as actief) {
            <div class="dl-condtagpaneel__states btn-group">
                <button type="button" class="btn btn-outline-secondary"
                        [class.active]="!condtagService.condtag()" (click)="klikUnset()">X
                </button>
                <button type="button" class="btn btn-outline-secondary dl-condtagpaneel__state-cond"
                        [class.active]="actief.state === 'cond'" (click)="klikState('cond')">?
                </button>
                <button type="button" class="btn btn-outline-secondary dl-condtagpaneel__state-cons"
                        [class.active]="actief.state === 'cons'" (click)="klikState('cons')">!
                </button>
            </div>
        }
    </div>
</div>
